import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, FormHelperText } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import WarningIcon from '@/assets/images/warning.svg';
const useStyles = makeStyles((theme) => ({
  root: {},
  dateComponent: {
    width: '100%',
    '& .MuiInputAdornment-positionEnd': {
      display: 'none',
    },
    '& .MuiInputLabel-root': {
      zIndex: 1,
      transform: 'translate(8px, 34px) scale(1)',
      fontSize: '16px',
      lineHeight: '24px',
      '&.MuiInputLabel-shrink': {
        color: '#575D65',
        fontSize: '12px',
        lineHeight: '16px',
        transform: 'translate(8px, 26px)',
      },
    },
    '& .MuiInput-root': {
      backgroundColor: '#F7F8F9',
    },
    '& .MuiInputBase-input': {
      height: '24px',
      padding: '24px 8px 8px 8px',
      color: theme.palette.$inputColor,
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600,
      letterSpacing: 0,
    },
    '& .MuiInput-underline': {
      '&::after': {
        borderBottom: '2px solid #005EFD',
      },
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `2px solid ${theme.palette.$lineGrey}`,
      },
      '&:hover::before': {
        borderBottom: `1px solid ${theme.palette.$lineGrey}`,
      },
      '&::before': {
        borderBottom: `1px solid ${theme.palette.$lineGrey}`,
      },
    },
    '& .MuiFormHelperText-contained': {
      margin: 0,
      padding: '8px',
      fontSize: '12px',
      lineHeight: '16px',
      color: '#575D65',
    },
    '& input::-webkit-inner-spin-button': {
      webkitAppearance: 'none',
    },
    'input::-webkit-outer-spin-button': {
      webkitAppearance: 'none',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: '#ED5347',
      marginTop: '8px',
      marginLeft: '8px',
      lineHeight: '16px',
      background: `url(${WarningIcon}) no-repeat`,
      paddingLeft: '18px',
    },
  },
  helperTextComponent: {
    fontSize: '12px',
    lineHeight: '16px',
    marginLeft: '8px',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'start',
  },
}));

const DateComponent = ({
  format, onChange, value, message, invalidDateMessage,
}) => {
  const classes = useStyles();
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        label="Date of birth"
        disableToolbar
        variant="filled"
        format={format}
        id="case_history_end_date"
        placeholder="dd/mm/yyyy"
        value={value}
        onChange={onChange}
        className={classes.dateComponent}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        invalidDateMessage={invalidDateMessage}
        maxDateMessage={invalidDateMessage}
        minDateMessage={invalidDateMessage}
      />
      {message && (
        <FormHelperText className={classes.helperTextComponent}>{message}</FormHelperText>
      )}
    </MuiPickersUtilsProvider>
  );
};

DateComponent.defaultProps = {
  format: 'dd/MM/yyyy',
  onChange: (_) => _,
  value: '',
  message: '',
  invalidDateMessage: '',
};

DateComponent.propTypes = {
  format: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  message: PropTypes.string,
  invalidDateMessage: PropTypes.string,
};

export default DateComponent;
